<template>
  <div
    class="btn-group"
    :class="{show, 'w-100': block}"
    v-click-outside="hideDropdown"
  >
    <button
      class="dropdown-toggle hide-arrow"
      :class="btnClass"
      type="button"
      data-toggle="dropdown"
      aria-expanded="false"
      @click="show = !show"
    >
      <span class="mr-2" v-if="text && translateText">{{ $t(text) }}</span>
      <span class="mr-2" v-else-if="text">{{ text }}</span>
      <span
        :class="{'mr-2': !!text}"
        class="spinner-border spinner-border-sm"
        v-if="isLoading"
        role="status"
        aria-hidden="true"
      ></span>
      <i
        v-else
        :class="['fa', `fa-${icon || 'chevron-down'}`]"
      ></i>
    </button>
    <div
      class="dropdown-menu dropdown-menu-right"
      :class="{show, 'align-left': alignment === 'left', 'align-right': alignment === 'right'}"
      x-placement="bottom-start"
      style="position: absolute; will-change: top, left; top: 38px;"
      @click="hideDropdown"
    >
      <slot name="menu"></slot>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'DropdownMenu',
  props: {
    alignment: {
      type: String,
      default() {
        return 'right';
      },
    },
    block: {
      type: Boolean,
      default() {
        return false;
      },
    },
    icon: {
      type: String,
    },
    loader: {
      type: Object,
      default() {
        return {
          auto: false,
          loading: false,
        };
      },
    },
    size: {
      default() {
        return 'md';
      },
    },
    styleType: {
      type: String,
      default() {
        return 'primary';
      },
    },
    text: {
      type: String,
    },
    translateText: {
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  directives: {
    'click-outside': ClickOutside,
  },
  methods: {
    hideDropdown() {
      if (this.show) {
        this.show = false;
      }
    },
  },
  computed: {
    isLoading() {
      return this.loader.loading || this.loading;
    },
    btnClass() {
      return [
        'btn',
        `btn-${this.styleType}`,
        this.block ? 'btn-block' : '',
        `btn-${this.size}`,
        this.rounded ? 'rounded-pill' : '',
      ];
    },
  },
};
</script>

<style scoped>
.btn-group .align-left {
  left: 0 !important;
}

.btn-group .align-right {
  right: 0 !important;
}
</style>
